import React from 'react';

const Catagories = () => <div>categories go here</div>;

export default Catagories;
